import { render, staticRenderFns } from "./ExportSosprog.vue?vue&type=template&id=13d74953"
import script from "./ExportSosprog.vue?vue&type=script&lang=js"
export * from "./ExportSosprog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports